import React from 'react'
import ReactDOM from 'react-dom'
import Banner from '../components/Banner'
import Calendar from '../components/Calendar'
import Downloads from '../components/Downloads'
import EventHomepage from '../components/EventHomepage'
import Footer from '../components/Footer'
import Hero from '../components/Hero'
import Partners from '../components/Partners'
import Button from '../components/UI/Button'
import { Column } from '../components/UI/Grid'
import { image } from '../constants/mock'
import { pages } from '../constants/site'
import { colors, cssFont, flex, media } from '../constants/style'
import withMenuHoC from '../HoCs/Menu'
import { filterPastEvents, scrollTo } from '../utils'

const WrapperEvents = Column.extend`
  padding-bottom: 0px;
  ${media.medium`
    padding-bottom: 40px;
  `};
`

const InnerEvents = Column.extend`
  flex-wrap: wrap;
  ${media.medium`
    flex-direction: row;
  `};
`

const Title = Column.extend`
  color: ${colors.red};
  font-size: 2rem;
  font-weight: 100;
  line-height: 2.5rem;
  padding: 20px 40px;
  ${media.medium`
    flex-direction: row;
    padding: 40px;
  `} strong {
    color: ${colors.red};
    font-size: 2rem;
    font-weight: bold;
    line-height: 2.5rem;
  }
`

const Subtitle = Column.extend`
  ${cssFont.title} padding: 0 40px;
`

const DownloadWrapper = Column.extend`
  ${media.medium`
    flex-direction: row;
  `};
`

class IndexPage extends React.Component {
  calendarRef = null
  componentDidMount() {
    sessionStorage.setItem('banner-visible', 'invisible')
  }
  render() {
    const { data, toggleMenu } = this.props
    const shows = data.allMarkdownRemark.edges

    const filteredShows = filterPastEvents(shows)

    let bannerVisible

    if (typeof window !== 'undefined') {
      bannerVisible = window.sessionStorage.getItem('banner-visible')
    }

    return (
      <Column>
        {/* Non cancellare questo div perchè serve al popup di mailup.com */}
        {bannerVisible !== 'invisible' && <div id="frm-mltchnl" />}
        <Hero
          onMenuClick={toggleMenu}
          onCalendarClick={() => {
            const node = ReactDOM.findDOMNode(this.calendarRef)
            const rect = node.getBoundingClientRect()
            scrollTo(rect.y - 100, null, 700)
          }}
        />

        <WrapperEvents grow={0}>
          <Column>
            <Title>
              {pages.SPETTACOLI.title}
              &nbsp;
              <strong>|&nbsp;{pages.SPETTACOLI.seasonName}</strong>
            </Title>
            <DownloadWrapper>
              <Subtitle>Prossimi Appuntamenti</Subtitle>
              <Downloads />
            </DownloadWrapper>
          </Column>

          <InnerEvents>
            {(filteredShows.length != 0) ? filteredShows.slice(0, 4).map((show, index) => (
              <EventHomepage key={index} data={show} />
            )) : <p style={{ padding: '40px', fontWeight: 'bold' }}>Gli spettacoli sono terminati e riprenderanno la prossima stagione!</p>}
          </InnerEvents>
        </WrapperEvents>

        <Banner image={image}>
          <Column
            align={flex.align.END}
            justify={flex.justify.CENTER}
            shrink={1}
          >
            <p>
              Clicca qui e scopri di più
              <br />
              <strong>sui nostri abbonamenti</strong>
            </p>
            <a href={pages.BIGLIETTERIA.link}>
              <Button>SCOPRI DI PIÙ</Button>
            </a>
          </Column>
        </Banner>

        <Calendar data={shows} ref={cref => (this.calendarRef = cref)} />

        <Partners />

        <Footer />
      </Column>
    )
  }
}

export default withMenuHoC(IndexPage)

export const query = graphql`

  query LastShowsQuery {
    ...MenuFragment
    allMarkdownRemark(
      sort: {
        fields: [frontmatter___date],
        order: ASC,
      },
      filter: {
        fileAbsolutePath: {
          regex: "/(\/collections\/shows)/.*\\.md$/"
        },
      },
    ) {
      edges {
        node {
          fields {
            slug
            category {
              fields {
                slug
              }
              frontmatter {
                title
                icon
                hidden
              }
            }
          }
          frontmatter {
            content
            date
            dates {
              date
            }
            gray
            image
            info
            link
            location
            officetime
            showtime
            slides {
              image
            }
            subtitle
            title
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js